<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listaProfissionals"
        title-table="Profissionais"
        module="professionsAtendimentoSettingsModule"
        sort-name="registro"
        add-permission="ROLE_PROFISSIONAL_INSERIR"
        view-permission="ROLE_PROFISSIONAL_CONSULTAR"
        edit-permission="ROLE_PROFISSIONAL_ATUALIZAR"
        delete-permission="ROLE_PROFISSIONAL_DELETAR"
        @add="addNew"
        @edit="edit"
      />
      <FormProfissional
        v-else
        @cancelar="cancelar"
      />
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol, BSpinner } from 'bootstrap-vue'
import mixinsGlobal from '@/mixins'
import FormProfissional from './forms/FormProfissional.vue'

export default {
  components: {
    BRow,
    BCol,
    BSpinner,
    TableComponents,
    FormProfissional,
  },
  mixins: [mixinsGlobal],
  data() {
    return {
      showForm: false,
      isLoading: false,
      columns: [
        { label: 'Id', field: 'id' },
        { label: 'Nº Registro', field: 'numeroRegistroProfissional' },
        { label: 'Nome', field: 'registro.nome' },
        { label: 'Conselho', field: 'conselho.descricao' },
        { label: 'Ativo', field: 'ativo' },
        { label: 'Action', field: 'action' },
      ],
    }
  },
  computed: {
    ...mapState('professionsAtendimentoSettingsModule', {
      listaProfissionals: state => state.listaProfissionals,
    }),
  },
  methods: {
    async addNew() {
      this.showForm = true
      this.isLoading = true
      try {
        await this.$store.dispatch(
          'professionsAtendimentoSettingsModule/resetObject',
        )
      } finally {
        this.isLoading = false
      }
    },
    async edit(data) {
      this.isLoading = true
      try {
        await this.$store.dispatch(
          'professionsAtendimentoSettingsModule/resetObject',
        )
        const response = await this.$store.dispatch(
          'professionsAtendimentoSettingsModule/getById',
          data.id,
        )

        if (!response || !response.data) {
          this.MensagemError('Erro', 'Não foi possível carregar os dados do profissional.')
          return
        }

        const obj = {
          ...response.data,
          especialidades: (response.data.especialidades || []).map(item => ({
            value: item.id,
            nome: item.descricao || item.nome,
          })),
        }
        await this.$store.dispatch(
          'professionsAtendimentoSettingsModule/prepareToEditProfissional',
          obj,
        )
        this.showForm = true
      } finally {
        this.isLoading = false
      }
    },
    cancelar() {
      this.showForm = false
    },
  },
}
</script>
